"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContestTags = void 0;
var ContestTags;
(function (ContestTags) {
    ContestTags["GOLF"] = "golf";
    ContestTags["NFL"] = "nfl";
    ContestTags["MULTI_ENTRY"] = "multientry";
    ContestTags["SINGLE_ENTRY"] = "singleentry";
    ContestTags["TOP_X"] = "topx";
    ContestTags["MULTIPLIER"] = "multiplier";
})(ContestTags || (exports.ContestTags = ContestTags = {}));
